var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 2.74999H17.4167V1.83332C17.4167 1.32916 17.0042 0.916656 16.5 0.916656C15.9958 0.916656 15.5833 1.32916 15.5833 1.83332V2.74999H6.41668V1.83332C6.41668 1.32916 6.00418 0.916656 5.50001 0.916656C4.99584 0.916656 4.58334 1.32916 4.58334 1.83332V2.74999H3.66668C2.65834 2.74999 1.83334 3.57499 1.83334 4.58332V19.25C1.83334 20.2583 2.65834 21.0833 3.66668 21.0833H18.3333C19.3417 21.0833 20.1667 20.2583 20.1667 19.25V4.58332C20.1667 3.57499 19.3417 2.74999 18.3333 2.74999ZM17.4167 19.25H4.58334C4.07918 19.25 3.66668 18.8375 3.66668 18.3333V7.33332H18.3333V18.3333C18.3333 18.8375 17.9208 19.25 17.4167 19.25Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.2ee9dd6e63587a1c6da0bd21b37774db.svg";
export { ForwardRef as ReactComponent };